import { View, Text } from "react-native";
import { LinkButton } from "../../components";

interface InstructionsProps {
  onMoreDetails: () => void;
}

const Instructions = ({ onMoreDetails }: InstructionsProps) => (
  <View className="bg-white px-6 py-8 items-start">
    <Text className="text-small-normal text-ink-dark">
      Saving your job preferences will allow us to provide you with a targeted list of positions and career advancement services
      as you become more active in your search.
    </Text>
    <LinkButton onPress={onMoreDetails}>More Details</LinkButton>
  </View>
);

export default Instructions;
